import { post, get, upload, del } from '../request.js'

// 分页查询发票报销列表
export const findAllInvoicePage = (params) => post('/invoice/findAllInvoicePage', params, true)

// 根据id查询发票报销详情
export const findOneInvoiceById = (params) => get('/invoice/findOneInvoiceById', params)

// 新增发票报销
export const saveInvoice = (params) => post('/invoice/saveInvoice', params, true)

// 批量新增发票报销（一次新增多种类型，共享报销人、发生日期、关联拜访）
export const saveInvoiceBatch = (params) => post('/invoice/saveInvoiceBatch', params, true)

// 编辑发票报销
export const updateInvoice = (params) => post('/invoice/updateInvoice', params, true)

// 删除发票报销
export const deleteInvoice = (params) => del('/invoice/deleteInvoice', params)

// 上传发票附件
export const uploadInvoiceFile = (params, query = '', progress) => upload(`/invoice/uploadFile${query}`, params, progress)

// 下载发票附件
export const downInvoiceFile = (params) => post('/invoice/downFile', params, false, true)

// 导出发票报销列表
export const downloadAllInvoiceList = (params) => post('/invoice/downloadAllInvoiceList', params, true, true)

// 导入发票报销列表
export const importInvoiceList = (params, progress) => upload('/invoice/importInvoiceList', params, progress)

// 下载导入模板
export const downloadImportTemplate = () => post('/invoice/downloadImportTemplate', {}, true, true)

// 获取销售离发生日期最近2周的拜访记录
export const findRecentVisits = (params) => post('/invoice/findRecentVisits', params, true)
